/**
 * Displays per-team hunt time remaining for hosts (matches player countdown rules).
 */

import React from 'react'
import PropTypes from 'prop-types'
import { formatTimeLeft, getTeamSecondsLeft } from '../../utils/team-timer'

export const getTeamTimeDisplayLabel = (team, duration, enableTimer, now = Date.now()) => {
  if (team && team.permanent) return null
  if (!enableTimer) return `Timer off`
  if (!team || !team.start_time) return `Not started`

  const secondsLeft = getTeamSecondsLeft(team, duration, enableTimer, now)
  if (secondsLeft === null) return `Not started`
  return formatTimeLeft(secondsLeft)
}

class TeamTimeRemaining extends React.Component {
  constructor(props) {
    super(props)
    this.state = { now: Date.now() }
    this.timer = null
    this.tick = this.tick.bind(this)
    this.startTimer = this.startTimer.bind(this)
    this.stopTimer = this.stopTimer.bind(this)
  }

  componentDidMount() {
    if (this.shouldTick()) {
      this.startTimer()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.shouldTick()) {
      this.startTimer()
    } else {
      this.stopTimer()
    }
  }

  componentWillUnmount() {
    this.stopTimer()
  }

  shouldTick() {
    const { team, enableTimer } = this.props
    if (!enableTimer || !team || team.permanent) return false
    return Boolean(team.start_time && !team.end_time)
  }

  startTimer() {
    if (!this.timer) {
      this.timer = setInterval(this.tick, 1000)
    }
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  tick() {
    this.setState({ now: Date.now() })
  }

  render() {
    const { team, duration, enableTimer, inline } = this.props
    const label = getTeamTimeDisplayLabel(team, duration, enableTimer, this.state.now)

    if (label === null) return null

    const secondsLeft = getTeamSecondsLeft(team, duration, enableTimer, this.state.now)
    const isOvertime = secondsLeft !== null && secondsLeft < 0

    if (inline) {
      return (
        <span className={isOvertime ? `text-danger` : undefined}>{label}</span>
      )
    }

    return (
      <span className={`d-block team-details`}>
        <strong>Time left</strong>{` `}
        <span className={isOvertime ? `text-danger` : undefined}>{label}</span>
      </span>
    )
  }
}

TeamTimeRemaining.propTypes = {
  team: PropTypes.object,
  duration: PropTypes.number,
  enableTimer: PropTypes.bool,
  inline: PropTypes.bool,
}

TeamTimeRemaining.defaultProps = {
  duration: 2,
  enableTimer: false,
  inline: false,
}

export default TeamTimeRemaining
